import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../css/featureDetail.css";

const FeatureMinimalDocs = () => (
  <>
    <Helmet>
      <title>Minimal Documentation — Paperless Loans | Salary Uncle</title>
      <meta name="description" content="Say goodbye to stacks of paperwork. Salary Uncle's minimal documentation process makes getting a salary loan quick and completely paperless." />
    </Helmet>

    <section className="fd-hero">
      <div className="fd-hero-inner">
        <Link to="/" className="fd-back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Back to Home
        </Link>
        <div className="fd-hero-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="9" y1="13" x2="15" y2="13"/>
            <line x1="9" y1="17" x2="11" y2="17"/>
          </svg>
        </div>
        <span className="fd-tag">FEATURE</span>
        <h1>Minimal Documentation</h1>
        <p>No stacks of papers. No long checklists. Just 3 documents and you're done — quick and completely paperless.</p>
      </div>
    </section>

    <section className="fd-body">
      <div className="fd-body-inner">
        <div className="fd-highlights">
          {[
            { title: "Only 3 Documents Required", desc: "Aadhaar card, PAN card, and latest salary slip — that's all we need." },
            { title: "Digital Uploads", desc: "Upload documents directly from your phone gallery or camera. No printing needed." },
            { title: "Auto-Verification", desc: "Our system auto-verifies documents in real time, cutting approval time drastically." },
            { title: "No Bank Visits", desc: "No need to go to a branch. Everything is submitted and verified online." },
            { title: "Instant KYC", desc: "Aadhaar-based eKYC ensures your identity is verified in seconds." },
            { title: "Safe & Confidential", desc: "Your documents are stored with end-to-end encryption and never shared without consent." },
          ].map((h, i) => (
            <div className="fd-highlight-card" key={i}>
              <div className="fd-hl-num">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="fd-hl-title">{h.title}</div>
                <div className="fd-hl-desc">{h.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="fd-steps-box">
          <h2>Documents You Need</h2>
          <div className="fd-steps">
            {[
              { step: "1", text: "Aadhaar Card — for address and identity proof." },
              { step: "2", text: "PAN Card — for tax and financial verification." },
              { step: "3", text: "Latest Salary Slip — to confirm income eligibility." },
              { step: "4", text: "Bank Account Details — for direct disbursal of loan amount." },
            ].map((s, i) => (
              <div className="fd-step-row" key={i}>
                <div className="fd-step-dot">{s.step}</div>
                <div className="fd-step-text">{s.text}</div>
              </div>
            ))}
          </div>
          <Link to="/apply-now" className="fd-cta-btn">Apply Now</Link>
        </div>
      </div>
    </section>
  </>
);

export default FeatureMinimalDocs;
